'use client'

import { ReactNode, useMemo } from 'react'

import { UserBalanceModel } from '@marketplace-web/escrow-pricing/escrow-pricing-data'

import UserBalanceContext from './UserBalanceContext'

type Props = {
  userBalance?: UserBalanceModel | null
  children: ReactNode
}

const UserBalanceProvider = ({ userBalance, children }: Props) => {
  const userBalanceMemo = useMemo(
    () => ({
      userBalance,
    }),
    [userBalance],
  )

  return (
    <UserBalanceContext.Provider value={userBalanceMemo}>{children}</UserBalanceContext.Provider>
  )
}

export default UserBalanceProvider
